module.exports = __webpack_public_path__ + "img/store_online_step1.a4966d9d.png";